import { render, staticRenderFns } from "./ednCalendar.vue?vue&type=template&id=3c4646be&"
import script from "./ednCalendar.vue?vue&type=script&lang=js&"
export * from "./ednCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ednCalendar.vue?vue&type=style&index=0&id=3c4646be&prod&lang=scss&"


/* normalize component */
import normalizer from "!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports